import React from "react";
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { ChartBox, colorAt, KitTooltip, num, EmptyState } from "./_kit";

/**
 * Pie / donut chart. Flat data list (no x-axis).
 * @param {{name:string,value:number,color?:string}[]} props.data
 * @param {boolean} [props.donut] - render as a donut
 * @param {string} [props.unit]
 */
export function RPieDonutChart({
  data = [], donut = false, nameKey = "name", dataKey = "value",
  unit, height = 320, formatValue = num, showLegend = true,
}) {
  if (!data.length) return <EmptyState />;

  return (
    <ChartBox $height={height}>
      <ResponsiveContainer>
        <PieChart>
          <Tooltip content={<KitTooltip unit={unit} formatValue={formatValue} />} />
          {showLegend && <Legend verticalAlign="bottom" iconType="circle" wrapperStyle={{ fontSize: 12 }} />}
          <Pie
            data={data}
            nameKey={nameKey}
            dataKey={dataKey}
            innerRadius={donut ? "58%" : 0}
            outerRadius="80%"
            paddingAngle={donut ? 2 : 0}
            isAnimationActive={false}
          >
            {data.map((d, i) => <Cell key={i} fill={d.color || colorAt(i)} />)}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    </ChartBox>
  );
}

export const RPieChart   = (props) => <RPieDonutChart {...props} donut={false} />;
export const RDonutChart = (props) => <RPieDonutChart {...props} donut />;
